"use client";

import { c as _c } from "react/compiler-runtime";
import type { Asset, UnresolvedLink } from "contentful";
import Image from "next/image";
import Link from "next/link";
import { trackRelatedProductClicked } from "@/lib/analytics/segment";
import { isAsset } from "@/lib/contentful/guards";
import { ContentfulHelper } from "@/utils/ContentfulHelper";
type AssetBlock = Asset<undefined, string> | UnresolvedLink<"Asset">;
interface Props {
  title: string;
  slug: string;
  sku: string;
  images: AssetBlock[];
  shortDescription?: string;
  isShortDescriptionIncluded?: boolean;
  priceLabel?: string;
}
export function RelatedProductCard(t0) {
  const $ = _c(25);
  const {
    title,
    slug,
    sku,
    images,
    shortDescription,
    isShortDescriptionIncluded,
    priceLabel
  } = t0;
  let t1;
  if ($[0] !== images) {
    const firstAsset = images.find(isAsset);
    t1 = firstAsset ? ContentfulHelper.parseContentfulContentImage(firstAsset) : null;
    $[0] = images;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const image = t1;
  const t2 = `/${slug}`;
  let t3;
  if ($[2] !== sku || $[3] !== slug || $[4] !== title) {
    t3 = () => trackRelatedProductClicked({
      title,
      slug,
      sku
    });
    $[2] = sku;
    $[3] = slug;
    $[4] = title;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== image) {
    t4 = image && <div className="relative mx-auto aspect-square w-full max-w-48 overflow-hidden rounded-md bg-card"><Image src={image.src} alt={image.alt} fill={true} className="object-contain" sizes="(min-width: 1024px) 25vw, (min-width: 768px) 50vw, 100vw" /></div>;
    $[6] = image;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== title) {
    t5 = <h3 className="text-base font-semibold leading-none text-card-foreground">{title}</h3>;
    $[8] = title;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] !== isShortDescriptionIncluded || $[11] !== shortDescription) {
    t6 = isShortDescriptionIncluded && shortDescription && <p className="text-sm leading-5 text-muted-foreground line-clamp-2">{shortDescription}</p>;
    $[10] = isShortDescriptionIncluded;
    $[11] = shortDescription;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  let t7;
  if ($[13] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <div className="flex-1" />;
    $[13] = t7;
  } else {
    t7 = $[13];
  }
  let t8;
  if ($[14] !== priceLabel) {
    t8 = priceLabel && <p className="text-sm font-bold leading-normal text-magento-darkgrey">{priceLabel}</p>;
    $[14] = priceLabel;
    $[15] = t8;
  } else {
    t8 = $[15];
  }
  let t9;
  if ($[16] !== t5 || $[17] !== t6 || $[18] !== t8) {
    t9 = <div className="flex flex-1 flex-col items-center gap-1.5 text-center">{t5}{t6}{t7}{t8}</div>;
    $[16] = t5;
    $[17] = t6;
    $[18] = t8;
    $[19] = t9;
  } else {
    t9 = $[19];
  }
  let t10;
  if ($[20] !== t2 || $[21] !== t3 || $[22] !== t4 || $[23] !== t9) {
    t10 = <Link href={t2} className="group flex flex-1 flex-col items-center space-y-6 p-6 rounded-md no-underline! focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring" onClick={t3}>{t4}{t9}</Link>;
    $[20] = t2;
    $[21] = t3;
    $[22] = t4;
    $[23] = t9;
    $[24] = t10;
  } else {
    t10 = $[24];
  }
  return t10;
}